import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Process from '../components/Process';
import Pricing from '../components/Pricing';
import Industries from '../components/Industries';
import Benefits from '../components/Benefits';
import Trust from '../components/Trust';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';
import { Toaster } from '../components/ui/sonner';

const HomePage = () => {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  useEffect(() => {
    // Set meta title
    document.title = 'Trademark Registration Services | Expert USPTO Filing | Trademark Restaurant Name';
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Professional trademark registration services with 95% USPTO approval rate. Expert trademark filing, search, and protection from $45. Over 1000+ trademarks successfully registered across the United States.';
    
    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = 'trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, federal trademark, trademark application';
  }, []);

  const handleContactClick = () => {
    setIsContactDialogOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={handleContactClick} />
      <Hero onContactClick={handleContactClick} />
      <About />
      <Services />
      <Process />
      <Pricing onContactClick={handleContactClick} />
      <Industries />
      <Benefits />
      <Trust onContactClick={handleContactClick} />
      <FAQ />
      <CTA onContactClick={handleContactClick} />
      <Contact onContactClick={handleContactClick} />
      <Footer />
      
      <ContactFormDialog
        open={isContactDialogOpen}
        onOpenChange={setIsContactDialogOpen}
      />
      
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default HomePage;
